import script from "./noticeCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./noticeCard.vue?vue&type=script&lang=ts&setup=true"

import "./noticeCard.vue?vue&type=style&index=0&id=1316ea2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1316ea2a"]])

export default __exports__